<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>反算管理</el-breadcrumb-item>
      <el-breadcrumb-item>月账单</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form
      :inline="true"
      :model="formInline"
      class="user-search"
      ref="searchbox"
      @submit.native.prevent
    >
      <el-form-item label="搜索：">
        <el-input
          placeholder="请输入计量点名称"
          @keyup.enter.native="search"
          v-model="formInline.meterPointName"
          size="small" clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          placeholder="请输入计量点地址"
          @keyup.enter.native="search"
          v-model="formInline.meterPointAddress"
          size="small" clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          size="small"
          v-model="formInline.month"
          type="month"
          value-format="yyyy-MM"
          placeholder="选择月"
		  style="width:120px" 
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item v-if="user.username == 'admin'" label="所属部门">
        <el-select
          v-model="formInline.departmentId"
          placeholder="请选择"
          size="small"
        >
          <el-option
            v-for="item in treeDate"
            :key="item.id"
            :label="item.departmentName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
	  <el-form-item label="选择数据项">
        <el-select v-model="currEnergy" multiple collapse-tags size="small" placeholder="请选择"
          @change="dateItemChange">
          <el-option v-for="item in dataOptions" :label="item.lable" :key="item.prop" :value="item.prop">
          </el-option>
        </el-select>
      </el-form-item>


      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
        <el-button
          size="small"
          type="success"
          :loading="loadStatus"
          icon="el-icon-download"
          @click="exportdata"
          >导出</el-button
        >
        <prems-button
          perms="pre:fs"
          label="执行反算"
          size="small"
          type="warning"
          @click="handlFs"
        />
		<prems-button
          perms="pre:pushToEIP"
          label="推送到EIP"
          size="small"
          type="warning"
		  :loading = "pushBillLoading"
          @click="pushBillMessageToEIP"
        />
      </el-form-item>
    </el-form>
    <!-- 数据列表 -->
    <el-table
      :header-cell-style="this.$store.state.headerCss"
      size="small"
      :data="dataList"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;"
      ref="tablelist"
      stripe
	  :row-key="get_row_key"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
      <el-table-column
        prop="id"
        label="ID"
        width="55"
        fixed="left"
      ></el-table-column>
      <el-table-column
        prop="meterPointName"
        label="电表名称"
        min-width="200"
        fixed="left"
      ></el-table-column>
      <!-- <el-table-column prop="meterPointAddress" label="电表编号" width="120">
      </el-table-column> -->
      <!-- <el-table-column prop="contractNo" label="合同号" width="120">
      </el-table-column> -->
      <el-table-column prop="isPay" label="是否预付费" width="90">
        <template slot-scope="scope">
          <span v-if="scope.row.isPay">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="payDay" label="账期" width="70">
      </el-table-column>
      <el-table-column prop="lastReading" label="上期电表读数" width="100">
      </el-table-column>
      <el-table-column prop="payDayReading" label="账期电表读数" width="100">
      </el-table-column>
      <el-table-column prop="magnification" label="倍率" width="70">
      </el-table-column>
      <el-table-column prop="monthUsed" label="用电量(kWh)" width="100">
      </el-table-column>
      <el-table-column prop="unitPrice" label="实际单价(元)" width="100">
      </el-table-column>
      <el-table-column prop="payDayCost" label="账期应扣金额(元)" width="120">
      </el-table-column>
      <el-table-column prop="usedCost" label="扣费金额(元)" width="100">
      </el-table-column>
      <el-table-column prop="lastBalance" label="上期余额(元)" width="100">
      </el-table-column>
      <el-table-column prop="lastAllowance" label="上期余量(kWh)" width="110">
      </el-table-column>
      <!-- <el-table-column prop="rechargeFee" label="充值金额(元)" width="120">
      </el-table-column>
      <el-table-column prop="refundFee" label="退款金额(元)" width="120">
      </el-table-column> -->
      <el-table-column prop="nowBalance" label="本期余额(元)" width="100">
      </el-table-column>
      <el-table-column
        prop="nextAllowance"
        label="下期可用余量(kWh)"
        width="130"
      >
      </el-table-column>

	  <template v-for="col in defaultCoulumn">
        <el-table-column align="center" :prop="col.prop" :label="col.lable" :key="col.prop" width="120"
          sortable>
          <template slot-scope="scope">    
              {{scope.row[ col.prop ]}}
          </template>
        </el-table-column>
      </template>
    </el-table>

    <Pagination
      v-bind:child-msg="formInline"
      @callFather="callFather"
      v-if="showPage"
    ></Pagination>
    <el-dialog title="执行反算" :visible.sync="dialogVisible" width="30%">
      <el-form
        :inline="true"
        :model="formInline"
        class="user-search"
        ref="searchbox"
        @submit.native.prevent
      >
        <el-form-item label="选择月份:">
          <el-date-picker
            size="small"
            v-model="fs_month"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="saveFs">确 定</el-button>
      </div>
    </el-dialog>

    <div class="showResult" v-if="showResult">
      <el-alert title="反算执行中……" type="success"> </el-alert>
    </div>
  </div>
</template>

<script>
import {
  findFinalBillData,
  exportFinalBillData,
  inverseBill
} from "../../api/userMG.js";
import { getDepartmentTerminalInfoLis } from "../../api/energyMG";
import { timestampToTime } from "@/utils/util";
import PremsButton from "@/views/permission/PreButtom";
import Pagination from "../../components/Pagination";
import { pushInverseBillToEip } from "@/api/prepayment.js";
export default {
  data() {
    return {
      loading: false,
      showPage: true,
      loadStatus: false,
      treeDate: [],
      currid: "",
      formInline: {
        total: 0,
        meterPointName: "",
        meterPointAddress: "",
        currentPage: 1,
        pageSize: 10,
        departmentId: "",
        contractNo: "",
        month: ""
      },
      dialogVisible: false,
      fsLoading: false,
      loadLoadin: false,
      user: {},
      fs_month: "",
      pushBillToEIPParam: {
        //推送到eip
        billIds: "", //账单id,以 ， 号进行分隔
        deptId: "", //部门id
        month: "" //月份
      },
      loadLoadin: false,
      dateData: [],
      dataList: [],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      showResult: false,
	  pushBillLoading:false,
	  dataOptions: [
	//   { prop: "payDay",lable: "账期"},
	  { prop: "meterPointAddress",lable: "电表编号"},
	  { prop: "contractNo",lable: "合同号"},
	//   { prop: "lastBalance",lable: "上期余额(元)"},
	//   { prop: "lastAllowance",lable: "上期余量(lWh)"},
	  { prop: "rechargeFee",lable: "充值金额(元)"},
	  { prop: "refundFee",lable: "退款金额(元)"},
	  ],
	  currEnergy: [],
	  defaultCoulumn:[],
    };
  },
  // 注册组件
  components: {
    Pagination,
    PremsButton
  },

  filters: {
      getWidth: function(val) {
        return 130


      }
    },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("userdata"));

    this.getJzData();
    this.formInline.month = this.getLastMonth();
  },
  methods: {
	get_row_key(row){
		return row.id
	},
    // 多选 勾选
    handleSelectionChange(data) {
      console.log("e----", data);
	  this.pushBillToEIPParam.billIds = (data.map(item=>item.id)).join(',')
	  console.log('this.pushBillToEIPParam.billIds',this.pushBillToEIPParam.billIds)
    },

    pushBillMessageToEIP() {
      this.pushBillToEIPParam.month = this.formInline.month;
      this.pushBillToEIPParam.deptId = this.formInline.departmentId;
	  this.pushBillLoading = true;
	  pushInverseBillToEip(this.pushBillToEIPParam).then(res=>{
		this.pushBillLoading = false;
		if(res.status == 1){
			this.$message.success(res.msg)
		}else{
			this.$message.error(res.msg)
		}

	  })
    },

	dateItemChange: function(val) {
        let col = val
        let arr = []
        this.dataOptions.forEach(item => {
          col.forEach(sitem => {
            if (item.prop == sitem) {
              arr.push(item)
            }
          })
        })

        // this.initDefault();
        this.defaultCoulumn = arr


      },

    exportdata(idx, row) {
      this.loadStatus = true;
      exportFinalBillData(this.formInline)
        .then(res => {
          var blob = new Blob([res], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
          }); //type这里表示xlsx类型
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = "月账单.xls"; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.loadStatus = false;
          this.$message.success("表格生成成功！正在下载");
        })
        .catch(err => {
          this.loadStatus = false;
          this.$message({
            message: "下载失败！",
            type: "error",
            showClose: true
          });
        });
    },

    getLastMonth() {
      var year, lastMonth;
      var date = new Date();
      var nowYear = date.getFullYear(); //当前年：四位数字
      var nowMonth = date.getMonth(); //当前月：0-11
      if (nowMonth == 0) {
        //如果是0，则说明是1月份，上一个月就是去年的12月
        year = nowYear - 1;
        lastMonth = 12;
      } else {
        //不是1月份，年份为当前年，月份本来是要减1的，但是由于`getMonth()`的月份本身就是少了1的，所以月份不用变。
        year = nowYear;
        lastMonth = nowMonth;
      }

      lastMonth = lastMonth < 10 ? "0" + lastMonth : lastMonth; //月份格式化：月份小于10则追加个0

      let lastYearMonth = year + "-" + lastMonth;

      return lastYearMonth;
    },

    search() {
      this.pageparm.currentPage = 1;
      this.formInline.currentPage = 1;
      this.showPage = false;
      this.getData();
      this.$nextTick(() => {
        this.showPage = true;
      });
    },
    //生成计算账单
    createComputData() {
      calMeterInfoPrice().then(res => {
        if (res.status == 1) {
          this.$message.success("操作成功！");
          this.getData();
        }
      });
    },
    //获取集中器信息
    getJzData: function() {
      return new Promise((resolve, reject) => {
        getDepartmentTerminalInfoLis().then(res => {
          this.treeLoad = false;
          if (res.status == 1) {
            let arr = [];
            this.treeDate = res.data.menuDepList;
            this.formInline.departmentId = res.data.menuDepList[0].id;
            this.getData();
            resolve(res.data.terIds);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },

    handlFs() {
      this.dialogVisible = true;
      this.fs_month = this.getLastMonth();
    },

    saveFs() {
      this.dialogVisible = false;
      this.showResult = true;
      let parm = {
        month: this.fs_month,
        departmentId: this.formInline.departmentId
      };
      inverseBill(parm).then(res => {
        this.showResult = false;
        if (res.status == 1) {
          this.$message.success("操作成功！");
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    getData() {
      this.loading = true;
      findFinalBillData(this.formInline)
        .then(res => {
          this.loading = false;
          if (res.status == 1) {
            this.dataList = res.data.data || [];
            this.formInline.currentPage = res.data.currentPage;
            this.formInline.pageSize = res.data.pageSize;
            this.formInline.total = res.data.totalCount;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error("获取数据失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.currentPage = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.getData();
    },
    getDate(val) {
      this.formInline.startTime = timestampToTime(this.dateData[0]).substring(
        0,
        10
      );
      this.formInline.endTime = timestampToTime(this.dateData[1]).substring(
        0,
        10
      );
      this.getData();
    }
  }
};
</script>

<style>
.showResult {
  position: fixed;
  top: 80px;
  right: 10px;
  transition: 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/views/prepayment/fsBill.vue